import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import notAuthenticatedRoutes from './NotAuthenticatedRoutes';
import UseAuthenticatedRoutes from './UseAuthenticatedRoutes';
import RouteLoader from './RouteLoader';

export default function Router() {
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const user = useSelector((state) => state.auth.user);
	const aRoute = UseAuthenticatedRoutes();

	const isAuth = !!isAuthenticated;

	const routesForAuthenticated = aRoute;
	const routesForNotAuthenticated = notAuthenticatedRoutes;
	const r = useMemo(() => {
		if (isAuthenticated) {
			if (!isAuth) {
				return routesForNotAuthenticated;
			} else {
				return routesForAuthenticated || [];
			}
		} else if (!isAuth && user) {
			return RouteLoader;
		} else {
			return routesForNotAuthenticated;
		}
	}, [isAuth, isAuthenticated, user, routesForAuthenticated, routesForNotAuthenticated]);

	const router = createBrowserRouter(r.length ? [...r] : []);

	return <RouterProvider router={router} />;
}
